export const returnPage = ({ route }) => {
  switch (route) {
    case '/docchat':
      return 'Docchat Dashboard';
    case '/doccompare':
      return 'DocCompare Dashboard';
    case '/profile':
      return 'Profile';
    case '/settings':
      return 'Settings';
    case '/viewer':
      return 'Viewer';
    case '/viewer-docchat':
      return 'Docchat Viewer';
    default:
      return null;
  }
};

export default { returnPage };
